import {CommonStatus} from "@/enums/status";

export class SiteParams {
    page? = 1;
    limit? = 10;
    search?: string;
    provinceId?: number;
    districtId?: number;
    wardId?: number;
    countryId? = 1;
    receivePostOfficeRowGuid?: string;
    receiveEmployeeRowGuid?: string;
    receivePartnerRowGuid?: string;
    deliveryPostOfficeRowGuid?: string;
    deliveryEmployeeRowGuid?: string;
    deliveryPartnerRowGuid?: string;
    status?: CommonStatus;
}
